import { FileText, Calendar, User } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { CaseStatusBadge } from './CaseStatusBadge';
import type { Case } from '../../types';

interface CaseCardProps {
  caseData: Case;
  onClick: (caseId: string) => void;
}

export function CaseCard({ caseData, onClick }: CaseCardProps) {
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });
  };

  const truncateNotes = (notes: string | undefined, maxLength: number = 100) => {
    if (!notes) return null;
    if (notes.length <= maxLength) return notes;
    return notes.substring(0, maxLength) + '...';
  };

  return (
    <Card
      className="cursor-pointer hover:shadow-md transition-shadow duration-200 hover:border-primary/50"
      onClick={() => onClick(caseData.id)}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-2">
          <CardTitle className="text-base font-semibold line-clamp-1">
            {caseData.name}
          </CardTitle>
          <CaseStatusBadge status={caseData.status} />
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        {caseData.notes && (
          <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
            {truncateNotes(caseData.notes)}
          </p>
        )}
        <div className="flex flex-wrap items-center gap-4 text-xs text-muted-foreground">
          <div className="flex items-center gap-1.5">
            <User className="h-3.5 w-3.5" />
            <span>{caseData.owner}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <FileText className="h-3.5 w-3.5" />
            <span>{caseData.document_count} document{caseData.document_count !== 1 ? 's' : ''}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Calendar className="h-3.5 w-3.5" />
            <span>{formatDate(caseData.created_at)}</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
